
























































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import ContentEditor from '@/dex-shared/components/new_content/ContentEditor.vue';
import AssertionsEditor from '@/components/question/assertions/AssertionsEditor.vue';
import MetadataEditor from '@/components/question/MetadataEditor.vue';
import KnowledgeAssociation from '@/components/knowledge/KnowledgeAssociation.vue';
import QuestionSourceEditor from '@/components/question/QuestionSourceEditor.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';

export default Vue.extend({
  components: {
    Content,
    ContentEditor,
    AssertionsEditor,
    MetadataEditor,
    KnowledgeAssociation,
    QuestionSourceEditor,
    Loading,
    pxButton,
    pxCard,
    ArrowRightIcon,
  },

  data() {
    return {
      creating: true,
      pushingQuestion: false,
      removingQuestion: false,
      loaded: true,
      oldContentString: '',
      similarQuestions: [],
      similarQuestionsLoading: false,
      similarQuestionsInterval: 10,
      similarQuestionsIntervalTime: 10,
      similarQuestionsIntervalTimeInterval: 1,
    };
  },

  computed: {
    ...mapGetters({
      questionById: 'questionById',
    }),
    question() {
      return this.questionById(+this.$route.params.questionId);
    },
  },

  async mounted() {
    this.loaded = false;
    this.creating = this.$route.name === 'question_create';
    if (this.creating) {
      const questionId = await this.$store.dispatch('CREATE_QUESTION');
      this.$router.push(`/editar_questao/${questionId}`);
    } else {
      const questionId = parseInt(this.$route.params.questionId);
      const err = await this.$store.dispatch('PULL_QUESTION_BY_ID', questionId);
      if (err == 404) {
        this.$router.push('/404');
      }
    }
    this.loaded = true;

    this.similarQuestionsIntervalTimeInterval = setInterval(() => {
      if (this.similarQuestionsIntervalTime >= 1)
        this.similarQuestionsIntervalTime--;
    }, 1000);
    this.similarQuestionsInterval = setInterval(async () => {
      this.similarQuestionsIntervalTime = 10;
      this.fulltextSearch();
    }, 11000);
  },

  async beforeDestroy() {
    clearInterval(this.similarQuestionsInterval);
    clearInterval(this.similarQuestionsIntervalTimeInterval);
  },

  methods: {
    pushQuestion: async function() {
      //TODO remove null contents
      if (this.pushingQuestion === false) {
        this.pushingQuestion = true;
        let error;
        try {
          await this.$store.dispatch('PUSH_QUESTION_BY_ID', this.question.id);
          await this.$store.dispatch('UPDATE_KNOWLEDGE_ASSOCIATIONS', {
            type: 'question',
            id: this.question.id,
          });
        } catch (e) {
          error = e;
          alert(
            `Algo deu errado. Envie essas informações para os desenvolvedores: ${error}`,
          );
        }
        this.pushingQuestion = false;
        if (this.question.id && !error) {
          this.$router.push(`/questao/${this.question.id}`);
        }
      }
    },
    removeQuestion: async function() {
      if (!this.removingQuestion) {
        this.removingQuestion = true;
        const response = await this.$store.dispatch(
          'REMOVE_QUESTION',
          this.question.id,
        );
        if (response !== true) {
          alert(
            `Algo deu errrado. Envie essas informações para os desenvolvedores: ${response}`,
          );
        } else {
          alert('Questão deletada!');
          this.$router.push('/questoes');
        }
        this.removingQuestion = false;
      }
    },

    fulltextSearch: async function() {
      this.similarQuestionsLoading = true;
      const newContentString = this.question.contentString();
      if (this.oldContentString !== newContentString) {
        this.oldContentString = newContentString;
        this.similarQuestions = await this.$store.dispatch(
          'GET_SIMILAR_QUESTIONS',
          newContentString,
        );
        this.similarQuestionsLoading = false;
      } else {
        setTimeout(() => {
          this.similarQuestionsLoading = false;
        }, 500);
      }
    },
  },
});
